module.exports = __webpack_public_path__ + "static/media/meta.3bde0f11.gif";